export function dmFileByAxios(response) {
  let fileName = ''
  let content = response.headers['content-disposition']
  if (content) {
    content = content.split('; ')
    let key = 'filename='
    for (const item of content) {
      let i = item.indexOf(key)
      if (i !== -1) {
        fileName = item.substring(i + key.length)
        break
      }
    }
  } else {
    fileName = Date.now() + '.xls'
  }
  if (!fileName) {
    throw Error('fileName is error!')
  }
  const url = window.URL.createObjectURL(
    new Blob([response.data], { type: response.headers['content-type'] })
  )
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', decodeURI(fileName))
  link.click()
  window.URL.revokeObjectURL(url)
}

export function isImgUrl(url) {
  return url && url.match(/\.(jpeg|jpg|gif|png)$/i) != null
}

export function isVideoUrl(url) {
  return url && url.match(/\.(mp4|flv|3gp|mkv|m4a|mov)$/i) != null
}

export function isAudioUrl(url) {
  return url && url.match(/\.(mp3|ogg)$/i) != null
}

export function createImgObj(response) {
  if (!response || !response.data) {
    return
  }
  const urlCreator = window.URL || window.webkitURL
  return urlCreator.createObjectURL(response.data)
}

export const LOCAL_ATTACHMENT_KEY = "unrelatedAttachments"

export function getUnrelatedAttachments(attachmentType) {
  let localAttachments = JSON.parse(localStorage.getItem(LOCAL_ATTACHMENT_KEY))
  if(Array.isArray(localAttachments)) {
    localAttachments = localAttachments.filter(e => e.businessType == attachmentType)
    return localAttachments
  } else {
    return []
  }
}

export function delUnrelatedAttachments() {
  localStorage.removeItem(LOCAL_ATTACHMENT_KEY)
}

export function delUnrelatedAttachment(attachmentType, index) {
  let localAttachments = getUnrelatedAttachments(attachmentType)
  localAttachments.splice(index, 1)

  localStorage.setItem(
    LOCAL_ATTACHMENT_KEY,
    JSON.stringify(localAttachments)
  )
}

export function setUnrelatedAttachments(newAttachments) {
  localStorage.setItem(
    LOCAL_ATTACHMENT_KEY,
    JSON.stringify(newAttachments)
  )
}